import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.64746 1.29688C7.08481 0.530478 8.05439 0.262599 8.81055 0.732422C9.03525 0.872061 9.22126 1.06683 9.35254 1.29688H9.35156L11.0215 4.22168C11.0425 4.25851 11.0735 4.27777 11.1006 4.28418L14.2822 5.03711H14.2832C15.1402 5.24023 15.6462 6.11364 15.4619 6.96289V6.96387C15.4056 7.22239 15.2883 7.46442 15.1182 7.66699L12.9678 10.2275C12.9423 10.2579 12.9265 10.3018 12.9307 10.3496L13.2275 13.7402C13.3033 14.6071 12.6906 15.4092 11.8105 15.4932C11.6128 15.5121 11.4144 15.4914 11.2256 15.4346L11.04 15.3662L8.04102 14.0234C8.01411 14.0115 7.98483 14.0114 7.95801 14.0234L4.95996 15.3662C4.14717 15.73 3.22425 15.3279 2.88965 14.5146C2.78907 14.27 2.74841 14.004 2.77148 13.7402L3.06934 10.3496C3.07345 10.3017 3.05762 10.2578 3.03223 10.2275L0.881836 7.66699C0.322209 7.0006 0.38402 5.9915 1.02734 5.40332L1.18066 5.2793C1.3418 5.16543 1.52348 5.08289 1.7168 5.03711L4.89941 4.28418C4.92653 4.27776 4.95657 4.25828 4.97754 4.22168L6.64746 1.29688Z",
      fill: "#ACC0DC",
      stroke: "white"
    }, null, -1)
  ])))
}
export default { render: render }